import {compose} from "redux";
import {Router, withRouter} from "next/router"

// Page component
import ResetPasswordPage from "../src/modules/authorization/pages/ResetPasswordPage";

// HOCs
import withUtils, {WithUtilsProps} from "../src/hoc/withUtils"
import withResetPassword, {WithResetPassword} from "../src/modules/authorization/hoc/withResetPassword"
import withAuthProtection from "../src/hoc/withAuthProtection"
import withDeviceTypeRedirect from "../src/hoc/withDeviceTypeRedirect"

export type ChangePasswordPageProps = {
    className?: string
    router: Router
} & WithUtilsProps & WithResetPassword

export default compose(
    withDeviceTypeRedirect,
    withAuthProtection,
    withRouter,
    withResetPassword,
    withUtils,
)(ResetPasswordPage)
